/**
 * The colour behaviour every lomda upload dropzone shares — border, fill and
 * both hover states. Geometry (height, radius, padding, gap) stays at the call
 * site, because the zones are deliberately different sizes.
 *
 * The hover fill is the point: the shared `UploadFile` defaults to
 * `hover:bg-muted` + `hover:border-slate-400`, a near-white neutral and a
 * hardcoded grey. On a dark lomda that filled the zone with white while its
 * text still inherited the page's white "Text", so the words vanished the
 * moment you hovered. tailwind-merge lets a className replace those utilities —
 * here with the theme's own Hover colour, the same token the knowledge-check
 * rows use.
 */
export const LOMDA_DROPZONE_FRAME_CLASS =
    "border-2 border-dashed border-[hsl(var(--lomda-border-dashed))] bg-[hsl(var(--lomda-background))]/40";
export const LOMDA_DROPZONE_CLASS = `${LOMDA_DROPZONE_FRAME_CLASS} text-center transition hover:border-[hsl(var(--lomda-border-active))] hover:bg-[hsl(var(--lomda-hover))]/40`;

export const LOMDA_DROPZONE_DRAG_CLASS =
    "border-[hsl(var(--lomda-border-active))] bg-[hsl(var(--lomda-hover))]/80";

// For a card whose `UploadFile` is an invisible layer: the layer takes the mark
// as its `dragClassName`, and the card lights up through `:has()`.
export const LOMDA_DROPZONE_DRAG_MARK = "lomda-dropzone-drag";
export const LOMDA_DROPZONE_DRAG_WITHIN_CLASS =
    "has-[.lomda-dropzone-drag]:border-[hsl(var(--lomda-border-active))] has-[.lomda-dropzone-drag]:bg-[hsl(var(--lomda-hover))]/80";
